import { render, staticRenderFns } from "./ExpositionsItem.vue?vue&type=template&id=755d63d9&"
import script from "./ExpositionsItem.vue?vue&type=script&lang=js&"
export * from "./ExpositionsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports